import { DateClass } from "../DateClass";

export class DataProcessor {
    constructor(nerodyti = {}) {
        this.nerodyti = nerodyti;
        this.datos = new DateClass();
    }

    visiAtsakymaiPagalKasPilde(atsakymai) {
        const ats = {};
        if (atsakymai) {
            atsakymai.forEach((single) => {
                const { imonesPavadinimas, kasPildo } = single.attributes;
                if (ats[imonesPavadinimas]) {
                    if (ats[imonesPavadinimas][kasPildo]) {
                        ats[imonesPavadinimas][kasPildo].push(single);
                    } else {
                        ats[imonesPavadinimas][kasPildo] = [single];
                    }
                } else {
                    ats[imonesPavadinimas] = { [kasPildo]: [single] };
                }
            });
        }
        return ats;
    }

    atsakymaiGrafikui(val = []) {
        return val
            .filter(e => e?.attributes?.atsakymai)
            .map(e => e.attributes.atsakymai);
    }

    formTipaiCsv(val = []) {
        return val
            .filter(e => e?.attributes?.formObject)
            .map(e => e.attributes.formObject);
    }

    beMetu(val = {}) {
        let x = {};
        Object.keys(val).forEach(e => {
            x = val[e];
        });
        return x;
    }

    sudeliojimasPagalDatas(info) {
        const iskirstomSukurimoDatom = {};
        if (!Array.isArray(info) || info.length === 0) {
            return iskirstomSukurimoDatom;
        }
        
        info.forEach(e => {
            if (e?.attributes?.uzpildymoData) {
                const i = this.datos.getYearFrom(new Date(e.attributes.uzpildymoData));
                if (iskirstomSukurimoDatom[i]) {
                    iskirstomSukurimoDatom[i].push(e);
                } else {
                    iskirstomSukurimoDatom[i] = [e];
                }
            }
        });
        return iskirstomSukurimoDatom;
    }

    datomParuostiAtsakymai(info) {
        const iskirstomSukurimoDatom = {};
        if (!Array.isArray(info) || info.length === 0) {
            return iskirstomSukurimoDatom;
        }
        
        info.forEach(e => {
            if (e?.attributes?.uzpildymoData && e?.attributes?.atsakymai) {
                const i = this.datos.getYearFrom(new Date(e.attributes.uzpildymoData));
                if (iskirstomSukurimoDatom[i]) {
                    iskirstomSukurimoDatom[i].push(e.attributes.atsakymai);
                } else {
                    iskirstomSukurimoDatom[i] = [e.attributes.atsakymai];
                }
            }
        });
        return iskirstomSukurimoDatom;
    }

    datomAtsakymai(info) {
        const iskirstomSukurimoDatom = {};
        if (!Array.isArray(info) || info.length === 0) {
            return iskirstomSukurimoDatom;
        }
        
        info.forEach(e => {
            if (e?.attributes?.uzpildymoData) {
                const i = this.datos.getYearFrom(new Date(e.attributes.uzpildymoData));
                if (iskirstomSukurimoDatom[i]) {
                    iskirstomSukurimoDatom[i].push(e);
                } else {
                    iskirstomSukurimoDatom[i] = [e];
                }
            }
        });
        return iskirstomSukurimoDatom;
    }

    visiAtsakymaiPagalImones(info) {
        const skirtingosImones = {};
        if (!Array.isArray(info) || info.length === 0) {
            return skirtingosImones;
        }
        
        info.forEach(e => {
            if (e?.attributes?.imonesPavadinimas && e?.attributes?.atsakymai) {
                const i = e.attributes.imonesPavadinimas;
                if (skirtingosImones[i]) {
                    skirtingosImones[i].push(e.attributes.atsakymai);
                } else {
                    skirtingosImones[i] = [e.attributes.atsakymai];
                }
            }
        });
        return skirtingosImones;
    }

    visiAtsakymaiPagalImonesIrDatas(atsakymai) {
        const datom = this.sudeliojimasPagalDatas(atsakymai);
        return Object.keys(datom).map(key => ({
            [key]: this.visiAtsakymaiPagalImones(datom[key])
        }));
    }

    puslapiaiIsTipu(tipai) {
        const pages = {};
        if (!Array.isArray(tipai) || tipai.length === 0) {
            return pages;
        }

        tipai.forEach(e => {
            if (e?.attributes?.formObject?.pages) {
                e.attributes.formObject.pages.forEach(page => {
                    if (page && page.name && page.elements && !this.nerodyti?.pages?.includes(page.name)) {
                        pages[page.name] = page.elements.filter(element => element !== null);
                    }
                });
            }
        });
        return pages;
    }

    puslapiuPavadinimai(tipai) {
        const pages = this.puslapiaiIsTipu(tipai);
        return [...new Set(Object.keys(pages))];
    }

    tipaiBeNereikalinguPuslapiu(tipai) {
        const pages = tipai.pages.filter(e => !this.nerodyti?.pages.includes(e.name));
        return { ...tipai, pages };
    }
}
